<!-- eslint-disable vue/no-v-html -->
<template>
  <base-modal
    :id="id"
    :key="id"
    :show-close-button="false"
    :show-footer="false"
    :close-on-click-outside="true"
    :show="show"
    class="seer-toast"
  >
    <base-icon
      icon="cancel"
      class="close-button"
      @click="close"
    />
    <div class="d-flex seer-toast-content">
      <base-icon
        v-if="status === 'error'"
        icon="exclamation-circle"
        class="mr-3 align-items-top"
        style="align-self: baseline;"
      />
      <base-icon
        v-else-if="status === 'success'"
        icon="check-circle"
        class="mr-3 align-items-top"
        style="align-self: baseline;"
      />
      <base-heading
        class="m-0 justify-content-center align-items-center text-center"
        v-html="message"
      />
    </div>
  </base-modal>
</template>
<script>
import { EventBus } from '@/event-bus';

export default {
  name: 'BaseToastModal',
  data() {
    return {
      id: '',
      status: '',
      message: '',
      show: false,
      onClose: null,
      onReload: false,
    };
  },
  mounted() {
    EventBus.$on('toast-success', (payload, timeout = 0, reload) => {
      setTimeout(() => {
        this.renderToast(payload, 'success', reload);
      }, timeout);
    });
    EventBus.$on('toast-error', (payload, timeout = 0) => {
      setTimeout(() => {
        this.renderToast(payload, 'error');
      }, timeout);
    });
    EventBus.$on('toast', (payload, timeout = 0) => {
      setTimeout(() => {
        this.renderToast(payload);
      }, timeout);
    });
  },
  methods: {
    renderToast(payload, status = 'success', reload) {
      this.id = `base-toast-modal-${Date.now()}`;
      this.status = status;
      this.message = typeof (payload) === 'string' ? payload : payload.message;
      this.show = true;
      this.onReload = reload;
      this.onClose = payload?.onClose;
    },
    close() {
      this.show = false;
      if (this.onClose) {
        this.onClose();
      }
      if (this.onReload) {
        console.log('here');
        window.location.reload();
      }
      EventBus.$emit('toast-closed');
    },
  },
};
</script>
<style lang="scss">
.seer-toast {
  .modal-dialog {
    max-width: 458px !important;

    .modal-content {
      width: 458px !important;
      border: none !important;
      border-radius: 12px !important;

      .modal-body {
        // padding: 53px 40px !important;
        padding: 0px !important;
      }
    }
  }
}
</style>
<style scoped lang="scss">
.close-button {
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  padding: 14px;
  cursor: pointer;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 0.6;
  }
}

.seer-toast-content {
  padding: 53px 40px;
}

.base-heading{
  font-family: $font-family-sans-serif-light;
}
</style>
